import { CSSProperties, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './ProgressCircle2.scss'
function ProgressCircle2(props: {
  progress: number
  maxValue: number
  customText?: string
  color: string
  innerDetails?: string
  details1?: string
  details2?: string
  icon?: string
  percentage?: string
}) {
  const { t } = useTranslation('common')

  const circleStyle: CSSProperties = {
    backgroundColor: props.color,
  }
  const percValue: number = props.progress <= 0 ? 0 : (props.progress / props.maxValue) * 100

  const [currentProgress, setProgress] = useState(0)

  useEffect(() => {
    if (Math.ceil(percValue) <= 0) {
      setTimeout(() => setProgress(0), 2)
      return
    }
    if (currentProgress < Math.ceil(percValue)) {
      setTimeout(() => setProgress(currentProgress + 1), 2)
    } else if (currentProgress > Math.ceil(percValue)) {
      setTimeout(() => setProgress(currentProgress - 1), 2)
    }
  }, [currentProgress, percValue])
  return (
    <>
      {props.percentage ? (
        <div className="flex circArea">
          <div className="progress-circle" data-progress={currentProgress}>
            <div className="circle">
              <div className="full progress-circle__slice">
                <div className="progress-circle__fill" style={circleStyle} />
              </div>
              <div className="progress-circle__slice">
                <div className="progress-circle__fill" style={circleStyle} />
                <div className="progress-circle__fill progress-circle__bar" style={circleStyle} />
              </div>
            </div>
            <div className="progress-circle__overlay">
              <div className="progress-circle-info">
                {props.icon ? (
                  <i className={props.icon} style={{ fontSize: '30px' }} />
                ) : (
                  !!props.innerDetails && <div className="detail">{props.innerDetails}</div>
                )}
              </div>
            </div>
          </div>
          <div className="percentage" style={{ color: `${props.percentage.includes('+') ? 'red' : 'green'}` }}>
            {props.percentage}
          </div>
        </div>
      ) : (
        <div className="flex circArea">
          <div className="progress-circle" data-progress={currentProgress}>
            <div className="circle">
              <div className="full progress-circle__slice">
                <div className="progress-circle__fill" style={circleStyle} />
              </div>
              <div className="progress-circle__slice">
                <div className="progress-circle__fill" style={circleStyle} />
                <div className="progress-circle__fill progress-circle__bar" style={circleStyle} />
              </div>
            </div>

            <div className="progress-circle__overlay">
              <div className="progress-circle-info">
                {props.icon ? (
                  <i className={props.icon} style={{ fontSize: '30px' }} />
                ) : (
                  !!props.innerDetails && <div className="detail">{props.innerDetails}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {!!props.details1 && (
        <div className="detail bottom">
          <div className="stats">
            <label>{t('ACT')}</label>
            {props.details1}
          </div>
          <div className="stats">
            <label>{t('EXP')}</label>
            {!!props.details2 && <> {props.details2}</>}
          </div>
        </div>
      )}
    </>
  )
}

export default ProgressCircle2
